// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-password-strength-bar {
  border-radius: 2px;
  transition: all 0.2s linear;
  height: 5px;
  margin-top: 4px;
}
.form-password-strength-bar.risky {
  background-color: #f95e68;
  width: 10%;
}
.form-password-strength-bar.guessable {
  background-color: #fb964d;
  width: 32.5%;
}
.form-password-strength-bar.weak {
  background-color: #fdd244;
  width: 55%;
}
.form-password-strength-bar.safe {
  background-color: #b0dc53;
  width: 77.5%;
}
.form-password-strength-bar.secure {
  background-color: #35cc62;
  width: 100%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
